import MarketGrowthPageShell from "../components/MarketGrowthPageShell";

const MarketGrowthPartnerLeadsPage = () => (
  <MarketGrowthPageShell
    title="لیدهای معرفی‌شده"
    description="نمای کلی لیدهای معرفی‌شده توسط شبکه نمایندگان (مدیریت)."
    empty
    emptyMessage="این بخش به‌زودی در دسترس خواهد بود."
  />
);

export default MarketGrowthPartnerLeadsPage;
